import { useTheme } from "@mui/material";
import Button from "./Button";
import { useLocation } from "react-router-dom";
import { FONT_WEIGHT_BUTTON } from "../../utils/constants";

const ButtonSlideMenu = ({
  menu = {},
  children,
  onClick,
  startIcon,
  endIcon,
  sx,
  id,
}) => {
  const location = useLocation();
  const theme = useTheme();
  const isRouteActive =
    location.pathname === menu.link ||
    (menu.activePathPrefix
      ? location.pathname.startsWith(menu.activePathPrefix)
      : false);
  const shouldShowSelectedStyle = isRouteActive && !menu.disabledSelectedStyle;

  const sxButtonSlideMenu = {
    border: "none",
    boxShadow: "none",
    justifyContent: "left",
    width: "100% !important",
    fontWeight: FONT_WEIGHT_BUTTON,
    "& .MuiSvgIcon-root": {
      marginLeft: "8px",
      color: shouldShowSelectedStyle
        ? "#fff !important"
        : "background.paperContrastText",
    },
    "&:hover": {
      backgroundColor: shouldShowSelectedStyle
        ? theme.palette.button.primary.main
        : "transparent",
    },
  };

  return (
    <>
      <Button
        id={id}
        hasShadow={false}
        color={shouldShowSelectedStyle ? "primary" : "secondary"}
        variant="contained"
        disableElevation
        fullWidth
        startIcon={startIcon}
        endIcon={endIcon}
        sx={{
          ...sxButtonSlideMenu,
          ...sx,
        }}
        onClick={onClick}
      >
        {children}
      </Button>
    </>
  );
};

export default ButtonSlideMenu;
